import { useSelector } from 'react-redux';
import { Message } from '@oneflowab/pomes';

import { getGuestToken } from 'agreement/selectors';

import BoxEmptyDraftState from 'components/box-empty-draft-state';
import Sigma from 'components/icons/sigma';

type Props = {
  isAllowedToAddBoxData: boolean,
  onClick: () => void,
};

const EmptyProductSumBox = ({
  isAllowedToAddBoxData,
  onClick,
}: Props) => {
  const isGuest = useSelector(getGuestToken);

  if (isGuest) {
    return null;
  }

  if (!isAllowedToAddBoxData) {
    return (
      <i>
        <Message
          id="No summations"
          comment="Text showing when there are no summations added yet."
        />
      </i>
    );
  }

  return (
    <BoxEmptyDraftState
      icon={Sigma}
      onClick={onClick}
      buttonText={(
        <Message
          id="Add product summation"
          comment="Action to create a new product summation."
        />
      )}
    />
  );
};

export default EmptyProductSumBox;
